import { createBrowserHistory } from "history";

/**
 * Historial de navegacion
 */
export const AppHistory = createBrowserHistory();
